import { render, staticRenderFns } from "./narcoticBlood.vue?vue&type=template&id=10e8e35a"
import script from "./narcoticBlood.vue?vue&type=script&lang=js"
export * from "./narcoticBlood.vue?vue&type=script&lang=js"
import style0 from "./narcoticBlood.vue?vue&type=style&index=0&id=10e8e35a&prod&lang=css"
import style1 from "./narcoticBlood.vue?vue&type=style&index=1&id=10e8e35a&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports